import EffectorEventInvocation from './effectors/EffectorEventInvocation';
import EffectorTransformScale from './effectors/EffectorTransformScale';
import EffectorObjectColor from './effectors/EffectorObjectColor';
import EffectorObjectFade from './effectors/EffectorObjectFade';
import EffectorHighlightSphere from './effectors/EffectorHighlightSphere';
import EffectorObjectAnimation from './effectors/EffectorObjectAnimation';
import EffectorTransformTranslate from './effectors/EffectorTransformTranslate';
import EffectorTransformRotateDeprecated from './effectors/EffectorTransformRotateDeprecated';
import EffectorVideoPlayback from './effectors/EffectorVideoPlayback';
import EffectorAudioPlayback from './effectors/EffectorAudioPlayback';
import { Timeline, TimelineSaveData } from './Timeline';
import EffectorTransformRotateSelf from './effectors/EffectorTransformRotateSelf';
import EffectorTransformRotatePivot from './effectors/EffectorTransformRotatePivot';
import EffectorBase from "./effectors/EffectorBase";
import TimelineTrack from "./TimelineTrack";
import { assert } from '../utilities/ErrorHandling';
import { TimelineEffectorTypes } from '../../globals';
import { ITimeline, ITimelineElement } from "../../interfaces/Timeline";
import store from '../../state/store';

type EffectorConstructor<T extends EffectorBase<any>> = new (...args: any[]) => T;

export const EffectorMap = new Map<TimelineEffectorTypes, EffectorConstructor<EffectorBase<any>>>([
	[TimelineEffectorTypes.EventInvocation, EffectorEventInvocation],
	[TimelineEffectorTypes.ObjectColor, EffectorObjectColor],
	[TimelineEffectorTypes.ObjectFade, EffectorObjectFade],
	[TimelineEffectorTypes.HighlightSphere, EffectorHighlightSphere],
	[TimelineEffectorTypes.ObjectAnimation, EffectorObjectAnimation],
	[TimelineEffectorTypes.TransformTranslate, EffectorTransformTranslate],
	[TimelineEffectorTypes.TransformRotate, EffectorTransformRotateDeprecated],
	[TimelineEffectorTypes.TransformRotateSelf, EffectorTransformRotateSelf],
	[TimelineEffectorTypes.TransformRotatePivot, EffectorTransformRotatePivot],
	[TimelineEffectorTypes.TransformScale, EffectorTransformScale],
	[TimelineEffectorTypes.VideoPlayback, EffectorVideoPlayback],
	[TimelineEffectorTypes.AudioPlayback, EffectorAudioPlayback],
]);

export const EffectorColorMap = new Map([
	[TimelineEffectorTypes.EventInvocation, "#D7AB7A"],
	[TimelineEffectorTypes.TransformTranslate, "#CBCD8F"],
	[TimelineEffectorTypes.TransformRotate, "#ACB32F"],
	[TimelineEffectorTypes.TransformRotateSelf, "#ACB32F"],
	[TimelineEffectorTypes.TransformRotatePivot, "#ACB32F"],
	[TimelineEffectorTypes.TransformScale, "#CAA61A"],
	[TimelineEffectorTypes.ObjectColor, "#CE5A75"],
	[TimelineEffectorTypes.ObjectFade, "#10CEA7"],
	[TimelineEffectorTypes.HighlightSphere, "#B558C9"],
	[TimelineEffectorTypes.ObjectAnimation, "#D02A49"],
	[TimelineEffectorTypes.VideoPlayback, "#537998"],
	[TimelineEffectorTypes.AudioPlayback, "#D6664B"],

]);

export const EffectorTitleMap = new Map([
	[TimelineEffectorTypes.EventInvocation, "Action"],
	[TimelineEffectorTypes.TransformTranslate, "Translate"],
	[TimelineEffectorTypes.TransformRotate, "Rotate"],
	[TimelineEffectorTypes.TransformScale, "Scale"],
	[TimelineEffectorTypes.ObjectColor, "Set Object Color"],
	[TimelineEffectorTypes.ObjectFade, "Fade Object In/Out"],
	[TimelineEffectorTypes.HighlightSphere, "Highlight Sphere"],
	[TimelineEffectorTypes.ObjectAnimation, "Animation Playback"],
	[TimelineEffectorTypes.VideoPlayback, "Video Playback"],
	[TimelineEffectorTypes.AudioPlayback, "Audio Playback"],
	[TimelineEffectorTypes.TransformRotateSelf, "Rotate"],
	[TimelineEffectorTypes.TransformRotatePivot, "Rotate Around Pivot"],
]);

export const timelineElementMap = new Map<string, ITimeline | ITimelineElement | TimelineTrack>();
export const timelineStepMap = new Map<string, Timeline>();

export function CreateTimeline(stepId: string, sceneId: string, loopTime?: number)
{
	assert(!timelineStepMap.has(stepId));
	const timelineLength = loopTime ?? store.getState().preferencesModule.editorPreferences.defaultTimelineLength ?? 10;

	timelineStepMap.set(stepId, new Timeline(stepId, sceneId, timelineLength));
	return timelineStepMap.get(stepId);
}

export function CreateTimelineFromSaveData(savedData: TimelineSaveData)
{
	assert(!timelineStepMap.has(savedData.stepId));
	const timelineLength = savedData.loopTime ?? store.getState().preferencesModule.editorPreferences.defaultTimelineLength ?? 10;
	const timeLine =  new Timeline(savedData.stepId, savedData.sceneId, timelineLength);
	timeLine.saveData = savedData;
}

export function GetTimelines()
{
	return Array.from(timelineStepMap.values());
}

export function GetTimeline(stepId: string)
{
	return timelineStepMap.get(stepId);
}
